import React, { Fragment, useEffect, useState } from 'react';
import { Button, Card, Col, Form, Modal, Row, Spinner } from 'react-bootstrap';
import { serviceGetApoderado, serviceRegistraApoderado } from '../../../../../api/api-antecendentes-legales';
import Mensajes from '../../../../mensajes';

const ModalApoderadoCIA = ({ show, onHide, apoderadoInicial, idInstancia, idCaso, idUsuario, onRegistrar }) => {
    const [nroTarjeta, setNroTarjeta] = useState('');
    const [nombre, setNombre] = useState('');
    const [email, setEmail] = useState('');
    const [paisCelular, setPaisCelular] = useState('57');
    const [celular, setCelular] = useState('');
    const [modoLectura, setModoLectura] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [responseData, setResponseData] = useState({});
    const [showToast, setShowToast] = useState(false);

    useEffect(() => {
        if (show) {
            if (apoderadoInicial?.nroTarjetaProf > 0) {
                setNroTarjeta(String(apoderadoInicial.nroTarjetaProf));
                setNombre(apoderadoInicial.nombreApoderado || '');
                setEmail(apoderadoInicial.emailApoderado || '');
                setPaisCelular(String(apoderadoInicial.paisCelular || 57));
                setCelular(apoderadoInicial.celular || '');
                setModoLectura(true);
            } else {
                limpiar();
            }
        }
    }, [show]);

    const handleNroTarjeta = async (value) => {
        const soloDigitos = value.replace(/\D/g, '').substring(0, 6);
        setNroTarjeta(soloDigitos);
        setErrors({});

        if (soloDigitos.length === 6) {
            setLoading(true);
            const response = await serviceGetApoderado({ accion: 4, nroTarjetaProf: Number(soloDigitos) });
            setLoading(false);
            if (response.code === 1 && response.object) {
                const apt = response.object;
                setNombre(apt.apt_var_nombre_apoderado || '');
                setEmail(apt.apt_var_email_apoderado || '');
                setPaisCelular(String(apt.apt_sma_paiscelular || 57));
                setCelular(apt.apt_var_celular || '');
                setModoLectura(true);
            } else {
                setModoLectura(false);
            }
        } else {
            setModoLectura(false);
            setNombre('');
            setEmail('');
            setPaisCelular('57');
            setCelular('');
        }
    };

    const limpiar = () => {
        setNroTarjeta('');
        setNombre('');
        setEmail('');
        setPaisCelular('57');
        setCelular('');
        setModoLectura(false);
        setErrors({});
    };

    const registrar = async () => {
        const errs = {};
        if (!nroTarjeta || nroTarjeta.length < 6) errs.nroTarjeta = 'Debe ingresar 6 dígitos';
        if (!nombre.trim()) errs.nombre = 'Nombre requerido';
        if (Object.keys(errs).length > 0) { setErrors(errs); return; }

        setLoading(true);
        const response = await serviceRegistraApoderado({
            accion: 5,
            nroTarjetaProf  : Number(nroTarjeta),
            nombreApoderado : nombre.trim(),
            emailApoderado  : email.trim()     || null,
            paisCelular     : paisCelular      ? Number(paisCelular) : null,
            celular         : celular.trim()   || null,
            idCaso,
            instanciaProceso: idInstancia,
            idUsuario
        });
        setLoading(false);
        setResponseData(response);
        setShowToast(true);

        if (response.code === 1) {
            onRegistrar({
                nroTarjetaProf  : Number(nroTarjeta),
                nombreApoderado : nombre.trim(),
                emailApoderado  : email.trim(),
                paisCelular     : paisCelular ? Number(paisCelular) : null,
                celular         : celular.trim()
            });
        }
    };

    const handleCloseToast = () => {
        setShowToast(false);
        if (responseData?.code === 1) onHide();
    };

    return (
        <Fragment>
            <Modal show={show} onHide={onHide} size='xl'>
                <Card>
                    <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#4F517A', color: 'white' }}>
                        Apoderado Implicado Tercero
                    </Card.Header>
                    <Card.Body>
                        <Row>
                            <Col md='3'>
                                <Form.Label className="is_required_apo">N° Tarjeta Profesional</Form.Label>
                                <Form.Control
                                    value={nroTarjeta}
                                    maxLength={6}
                                    disabled={modoLectura || loading}
                                    autoFocus={!modoLectura}
                                    onChange={e => handleNroTarjeta(e.target.value)}
                                />
                                {errors.nroTarjeta && <Form.Text style={{ color: 'red' }}>{errors.nroTarjeta}</Form.Text>}
                            </Col>
                            <Col md='3'>
                                <Form.Label className="is_required_apo">Apoderado Implicado(s) Tercero</Form.Label>
                                <Form.Control
                                    value={nombre}
                                    maxLength={100}
                                    disabled={modoLectura || loading}
                                    onChange={e => setNombre(e.target.value)}
                                />
                                {errors.nombre && <Form.Text style={{ color: 'red' }}>{errors.nombre}</Form.Text>}
                            </Col>
                            <Col md='3'>
                                <Form.Label>Email</Form.Label>
                                <Form.Control
                                    value={email}
                                    maxLength={100}
                                    disabled={loading}
                                    onChange={e => setEmail(e.target.value)}
                                />
                            </Col>
                            <Col md='3'>
                                <Form.Label>Móvil</Form.Label>
                                <Row>
                                    <Col xs='4'>
                                        <Form.Control
                                            value={paisCelular}
                                            maxLength={4}
                                            disabled={loading}
                                            placeholder='57'
                                            onChange={e => setPaisCelular(e.target.value.replace(/\D/g, ''))}
                                        />
                                    </Col>
                                    <Col xs='8'>
                                        <Form.Control
                                            value={celular}
                                            maxLength={15}
                                            disabled={loading}
                                            onChange={e => setCelular(e.target.value.replace(/\D/g, ''))}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Card.Body>
                    {showToast &&
                        <Mensajes
                            showToast={showToast}
                            handleCloseToast={handleCloseToast}
                            delay={3000}
                            responseData={responseData}
                        />
                    }
                    <Card.Footer style={{ display: 'flex', justifyContent: 'right', gap: '8px' }}>
                        <Button className='w-auto' variant='outline-info' onClick={onHide} disabled={loading}>
                            Volver
                        </Button>
                        <Button className='w-auto' variant='warning' onClick={limpiar} disabled={loading}>
                            Limpiar
                        </Button>
                        <Button className='w-auto' variant='danger' onClick={registrar} disabled={loading}>
                            {loading && <Spinner as="span" animation="border" size="sm" className="me-2" />}
                            Registrar
                        </Button>
                    </Card.Footer>
                </Card>
            </Modal>
            <style type='text/css'>
                {`
                    .is_required_apo:after {
                        content: "(*)";
                        margin-left: 2px;
                        color: #000;
                        font-weight: 500;
                        font-size: 12pt;
                    }
                `}
            </style>
        </Fragment>
    );
};

export default ModalApoderadoCIA;
